import { CurrencySchema,
  InvoiceBillingStatusSchema,
  InvoiceCalculationStatusSchema,
  InvoicePaymentProviderInformationSchema,
  PAYMENT_TERMS,
  PeriodSchema,
  RevenueBreakdownSchema,
  PromotionLineItemSchema,
  RevisionedLineItemSchema, SystemEventSchema, 
  CustomerSchema, 
  ApiDateSchema, 
  InvoiceReviewStatusSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { LightInvoiceCommitmentLineItemSchema } from './get-light-invoice-commitment-line-item-schema';
import { LightInvoiceFixedLineItemSchema } from './get-light-invoice-fixed-line-item-schema';
import { LightInvoiceUsageLineItemSchema } from './get-light-invoice-usage-line-item-schema';

export const GetLightInvoicesResponseSchema = oz.object({
  invoices: oz.array(oz.object({
    id: oz.string(),
    name: oz.string(),
    customer: CustomerSchema,
    currency: CurrencySchema,
    notes: oz.string().optional(),
    totalCommitment: oz.number(),
    taxRate: oz.number().min(0).max(100),
    issuedAt: ApiDateSchema,
    dueDate: ApiDateSchema,
    revenueBreakdown: RevenueBreakdownSchema,
    billingCycle: PeriodSchema,
    purchaseOrder: oz.string().optional(),
    fixedLineItems: oz.array(LightInvoiceFixedLineItemSchema),
    usageLineItems: oz.array(LightInvoiceUsageLineItemSchema),
    commitmentLineItems: oz.array(LightInvoiceCommitmentLineItemSchema),
    promotionLineItems: oz.array(PromotionLineItemSchema),
    revisionedLineItems: oz.array(RevisionedLineItemSchema),
    paymentDueDays: oz.number(),
    paymentProviderInformation: InvoicePaymentProviderInformationSchema.optional(),
    paymentTerm: oz.nativeEnum(PAYMENT_TERMS),
    reviewStatus: InvoiceReviewStatusSchema,
    billingStatus: InvoiceBillingStatusSchema,
    calculationStatus: InvoiceCalculationStatusSchema,
  })),
  invoicesSystemEvents: oz.array(SystemEventSchema),
}).openapi('GetLightInvoicesResponse');

export type GetLightInvoicesResponse = oz.TypeOf<typeof GetLightInvoicesResponseSchema>;